var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('AppBrandWarning'),_c('AppHeader'),_c('AppNavigation'),_c('vue-progress-bar'),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }